import { usePermit2 } from '@/presentation/context/permit2';
import { useApprove as useNftxApprove } from '@nftx/react';

const useApprove = () => {
  const [, setPermit2] = usePermit2();
  return useNftxApprove({
    onSuccess({ receipt }) {
      // If this was a permit2 approval we want to store the signature data in the context
      // This means the thing we're approving it for can then use/encode/pass-on the signature
      // If this wasn't a permit2 approval, this will just set the state to undefined
      setPermit2({ permit2Signature: receipt.permit2Signature });
    },
  });
};

export default useApprove;
